import { Div, P } from '@kizi/core-components';
import { IconV2 } from '@kizi/shared-components';
import React from 'react';

export const AvailabilityIcon = (item) => {
  const availability = item?.available ?? 0;
  let remarks = item?.remarks || '';

  remarks = remarks.replace(/&euro;/gi, '€');

  const iconName = {
    '-1': 'small-cancel',
    0: 'small-cancel',
    1: 'green-check',
    2: 'small-plus',
  };

  return (
    <Div display="flex" alignItems="center">
      <Div>
        <IconV2
          variant="optionalBig"
          ml="-10px"
          name={iconName[availability]}
          size="28px"
        />
      </Div>
      {availability > 0 && <P ml={1}>{remarks}</P>}
    </Div>
  );
};
